import Vue from "vue";
import $ from "jquery";
import {
  API_ROOT,
  API_ROOT_V2,
  API_ROOT_V4,
  API_PARTICIPANT_PORTAL,
  API_ROOT_STUDY_RESPONSE,
  API_PARTICIPANT_WEB_ROOT,
  COGNITO_API_US_WEB_ROOT,
  API_PARTICIPANT_PORTAL_V4,
  participants,
  surveys,
  profile,
  version,
  studies,
  language,
  instance,
  translate,
  schedules,
  checkschedules,
  learnmore,
  adherence,
  activities,
  mobilejson,
  studyVersion,
  configuration,
  participantweb,
  participantWeb,
  registrationform,
  forgotParticipantPassword,
  tasksAdherence,
  surveyManagement,
  responsemanagement,
  participantManagement,
  participantTaskSchedules,
  webbitriseurl,
  applangaTranslated,
  changepassword,
  smstoggle,
  withdrawstudy,
  studyappmetadata,
  studyManagement,
  clearNotifications,
  participantTaskNotifications,
  taskSchedules,
  participant,
  notifications,
  scheduleDay,
  country,
  paprticipantLanguageStatic,
  languages,
  participantportalsignout,
  forgotUsername,
  otp,
  send,
  checkUsername,
  API_ROOT_V3,
  updateEmail,
  emailVerificationStatus,
  verify,
  username,
  verifyOtp,
  register,
  webRegister,
  generatejwttoken,
  activate,
  signup,
  learnmorefeedback,
  consent,
  onboarding,
  cohort,
  consents,
  eula,
  general,
  email,
  pi,
  webapp,
  sites,
  contact,
  telehealth2,
  appointment,
  appointmentStatus,
  appointmentReschedule,
  mobiledocuments,
  site,
  address,
  configured,
  document,
  device,
  rejectVideoCall,
  videocallDetails,
  updateemail,
  statusKey,
  status,
  confirm,
  start,
  videos,
  resend,
  phone,
  verification,
  studyDetails,
  approvedlanguages,
  linkedLanguages,
  linkedCountries,
  requestDeleteAccount,
  datavant
} from "./urls";

const clientId = window.localStorage.getItem("thread-clientId");
const javaAccessTokenForParticipantResource = Vue.resource(`${API_PARTICIPANT_PORTAL_V4}${participantManagement}${participants}/${generatejwttoken}`);

const participantVerifyEmail = Vue.resource(
  `${API_ROOT_V2}${participantManagement}${participants}/${email}/${verify}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantEmailStatus = Vue.resource(
  `${API_ROOT}${participantManagement}${participants}{/participantId}/${participantweb}/${verification}/${status}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantCognitoVerifyEmail = Vue.resource(
  `${COGNITO_API_US_WEB_ROOT}${participant}/${email}/${statusKey}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const saveParticipantEligibility = Vue.resource(
  `${API_ROOT}${responsemanagement}${onboarding}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const saveConfirmParticipant = Vue.resource(
  `${API_ROOT}${participantManagement}${participants}{/pid}/${start}/${confirm}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantDocuments = Vue.resource(`${API_ROOT_V2}${participantManagement}${participants}{/pid}/${mobiledocuments}`, {}, { update: { method: "PUT" } });

const participantAddress = Vue.resource(`${API_ROOT}${participantManagement}${participants}{/pid}/${site}/${address}`, {}, { update: { method: "PUT" } });

const participantDeviceRegister = Vue.resource(`${API_ROOT_V2}${participantManagement}${participants}/${device}/${register}`, {}, { update: { method: "PUT" } });

const getParticipantVideosResource = Vue.resource(`${API_ROOT}${studyManagement}${studies}{/studyId}/${participants}{/pid}/${learnmore}/${videos}`);
const saveParticipantDocument = Vue.resource(
  `${API_ROOT_V2}${participantManagement}${participants}{/pid}/${studies}{/studyId}/${configured}/${document}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const editEmailSave = Vue.resource(
  `${API_ROOT_V3}${participantManagement}${participants}{/pid}/${updateemail}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantJoinStudyRegistration = Vue.resource(
  `${API_PARTICIPANT_PORTAL}${participantManagement}${participants}/${signup}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const participantJoinStudyRegistrationCognito = Vue.resource(
  `${API_ROOT_V4}${participantManagement}${participants}/${signup}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const saveParticipantEulaAgrement = Vue.resource(
  `${API_ROOT_V2}${participantManagement}${participants}{/pid}/${eula}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const saveParticipantCohort = Vue.resource(
  `${API_ROOT_V2}${participantManagement}${participant}/${cohort}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const saveParticipantConsent = Vue.resource(
  `${API_ROOT_V2}${responsemanagement}${onboarding}/${consent}{/consentID}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const saveParticipantDatavantConsent = Vue.resource(
  `${API_ROOT}${responsemanagement}${onboarding}/${datavant}/${consent}{/consentID}`, {}, {
    update: {
      method: 'PUT'
    }
},
);
const saveParticipantConsentOnBording = Vue.resource(
  `${API_ROOT_V2}${responsemanagement}${participants}{/pid}{/studyId}/${consents}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantSignatureAndDisclamer = Vue.resource(
  `${API_ROOT_V3}${participantManagement}${participants}{/pid}/${consents}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantDatavantSignatureAndDisclamer = Vue.resource(
  `${API_ROOT}${participantManagement}${participants}{/pid}/${datavant}/${consents}`, {}, {
  update: {
    method: 'PUT'
  }
},
);

const participantProfileLearnFeedback = Vue.resource(
  `${API_ROOT}${responsemanagement}${learnmorefeedback}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantJoinStudyActivate = Vue.resource(`${API_ROOT}${participantManagement}${participants}/${activate}`, {}, { update: { method: "PUT" } });

const participantCountry = Vue.resource(`${API_ROOT}${studyManagement}${country}`, {}, { update: { method: "PUT" } });

const participantLanguages = Vue.resource(`${API_ROOT}${studyManagement}${languages}`, {}, { update: { method: "PUT" } });

const participantStaticLanguages = Vue.resource(`${API_ROOT}${participantManagement}${participants}/${language}{/languageId}/${translate}/${paprticipantLanguageStatic}`, {}, { update: { method: "PUT" } });

const participantStudies = Vue.resource(`${API_PARTICIPANT_PORTAL}${participantManagement}${participants}/${instance}/${studies}`, {}, { update: { method: "PUT" } });

const firebaseWebApp = Vue.resource(`${API_ROOT}${participantManagement}${participants}/{pId}/${webapp}`, {}, { update: { method: "PUT" } });

const participantRegenerateTask = Vue.resource(`${API_ROOT}${surveyManagement}${surveys}{/taskId}/${mobilejson}`, {}, { update: { method: "PUT" } });

const participantsWebLanguageTranslations = Vue.resource(`${API_ROOT}${participantManagement}${participants}/${studies}{/studyId}/${language}{/languageId}/${translate}`);

const getParticipantsCountryLanguages = Vue.resource(`${API_PARTICIPANT_PORTAL}${participantManagement}${studies}/${instance}/${configuration}`, {}, { update: { method: "PUT" } });

const availableLanguagesConfiguration = Vue.resource(`${API_ROOT_V3}${participantManagement}${studies}{/studyId}/${participants}/${instance}/${linkedLanguages}`);

const availableCountryConfiguration = Vue.resource(`${API_ROOT_V3}${participantManagement}${studies}{/studyId}/${participants}/${instance}/${linkedCountries}`);

const getParticipantsConfiguration = Vue.resource(`${API_ROOT_V2}${participantManagement}${studies}{/studyId}/${participants}/${configuration}/${studyVersion}{/studyVersionId}`, {}, { update: { method: "PUT" } });

const participantsProfileDetails = Vue.resource(`${API_ROOT_V2}${participantManagement}${participants}{/pid}/${profile}`, {}, { update: { method: "PUT" } });

const participantsScheduledActivities = Vue.resource(`${API_ROOT}${responsemanagement}${participants}{/participantId}/${version}{/studyVersionId}/${schedules}/${participantTaskSchedules}`, {}, { update: { method: "PUT" } });

const participantsNotifications = Vue.resource(`${API_ROOT}${responsemanagement}${participants}{/participantId}/${version}{/studyVersionId}/${schedules}/${participantTaskNotifications}`, {}, { update: { method: "PUT" } });

const participantSingleNotification = Vue.resource(`${API_ROOT}${responsemanagement}${participants}{/pid}/${clearNotifications}`, {}, { update: { method: "PUT" } });

const participantAllNotification = Vue.resource(`${API_ROOT}${responsemanagement}${participant}{/pid}/${version}{/studyVersionId}/${notifications}/${scheduleDay}/{day}`, {}, { update: { method: "PUT" } });

const participantsClearNotifications = Vue.resource(`${API_ROOT}${responsemanagement}${participants}{/pid}/${notifications}`, {}, { update: { method: "PUT" } });

const participantsProfileDetailsf = Vue.resource(`${API_ROOT}${participantManagement}${participants}{/pid}/${profile}`, {}, { update: { method: "PUT" } });

const participantPortalData = Vue.resource(`${API_ROOT_V2}${participantManagement}${participants}/${studies}{/studyId}/${version}/${webbitriseurl}`, {}, { update: { method: "PUT" } });

const learnMoreData = Vue.resource(`${API_ROOT_V2}${participantManagement}${participants}/${studies}{/studyId}/${version}{/versionId}/${learnmore}`, {}, { update: { method: "PUT" } });

const participantPortalActivityDetails = Vue.resource(`${API_ROOT}${surveyManagement}${surveys}{/surveyId}/${mobilejson}`, {}, { update: { method: "PUT" } });

const getParticipantsApplangaTranslation = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${participantManagement}${participants}/${studies}{/studyId}/${version}{/studyVersionId}/${language}{/languageId}/${applangaTranslated}`, {}, { update: { method: "GET" } });

const participantDashboardPortalData = Vue.resource(`${API_ROOT_V2}${responsemanagement}${participants}/{pid}/${tasksAdherence}`, {}, { update: { method: "POST" } });

const participantDashboardPortalDetails = Vue.resource(`${API_ROOT}${responsemanagement}${adherence}`, {}, { update: { method: "PUT" } });

const participantSurveyPostDetails = Vue.resource(`${API_ROOT}${responsemanagement}${participants}/${taskSchedules}`, {}, { update: { method: "PUT" } });

const participantSendOtp = Vue.resource(`${API_ROOT}${participantManagement}${participants}/${forgotParticipantPassword}`, {}, { update: { method: "POST" } });

const participantSendOtpToEmail = Vue.resource(`${API_ROOT}${participantManagement}${participants}/${participantweb}/${forgotParticipantPassword}`, {}, { update: { method: "POST" } });

const changePasswordFact = Vue.resource(
  `${API_ROOT}${participantManagement}${participants}{/pid}/${changepassword}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const withdrawStudy = Vue.resource(
  `${API_ROOT_V2}${participantManagement}${participants}{/pid}/${withdrawstudy}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const deleteParticipantAccount = Vue.resource(
  `${API_ROOT}${participantManagement}${participants}{/pid}/${requestDeleteAccount}?participantId={participantId}`,
  {},
  {
    update: {
      method: "POST"
    }
  }
);

const participantSmsToggle = Vue.resource(`${API_ROOT_V2}${participantManagement}${participants}{/pid}/${smstoggle}`, {}, { update: { method: "PUT" } });

const participantVerificationSmsToggle = Vue.resource(`${API_ROOT_V2}${participantManagement}${participants}{/pid}/${verification}/${smstoggle}`, {}, { update: { method: "PUT" } });

const ActivityDetailswithImageUrl = Vue.resource(`${API_ROOT}${surveyManagement}${surveys}{/surveyId}/${participantweb}/${activities}`, {}, { update: { method: "PUT" } });

const getStudyAppMetadata = Vue.resource(`${API_ROOT}${studyManagement}/${studies}{/studyId}/${studyappmetadata}`, {}, { update: { method: "PUT" } });

const getParticipantTodayActivity = Vue.resource(`${API_ROOT}${responsemanagement}${participants}/${taskSchedules}`, {}, { update: { method: "PUT" } });

const participantsSurveyResponse = Vue.resource(`${API_ROOT}${responsemanagement}${surveys}`, {}, { update: { method: "PUT" } });

const participantsActivityResponse = Vue.resource(`${API_ROOT_V2}${responsemanagement}${surveys}`, {}, { update: { method: "PUT" } });

const participantsActivitiesResponse = Vue.resource(`${API_ROOT}${responsemanagement}${activities}`, {}, { update: { method: "PUT" } });

const participantsRegistrationConfig = Vue.resource(`${API_PARTICIPANT_WEB_ROOT}${participantWeb}${studies}{/studyId}/${participantweb}/${registrationform}`, {}, { update: { method: "PUT" } });

const participantsWebCountryLanguages = Vue.resource(`${API_PARTICIPANT_WEB_ROOT}${participantWeb}${studies}{/studyId}/${version}{/version}/${languages}`, {}, { update: { method: "PUT" } });

const participantPortalSignoutV3 = Vue.resource(
  `${API_ROOT_V3}${participantManagement}${participants}{/pid}/${participantportalsignout}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const forgotUsernameResource = Vue.resource(
  `${COGNITO_API_US_WEB_ROOT}${participant}/${forgotUsername}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const getParticipantWebTranslateData = Vue.resource(`${API_ROOT}${participantManagement}${participants}/${studies}{/studyId}/${language}{/languageId}/${translate}`, {}, { update: { method: "GET" } });

const getParticipantSiteApprovedLang = Vue.resource(`${API_ROOT}${participantManagement}${participants}/${approvedlanguages}`, {}, { update: { method: "PUT" } });

//61129 start
const verifyRegistrationPhoneOtp = Vue.resource(
  `${API_ROOT}${participantManagement}${participants}{/pid}/${verify}/${otp}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const resendRegistrationPhoneOtp = Vue.resource(
  `${API_ROOT}${participantManagement}${participants}{/pid}/${resend}/${phone}/${otp}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantStudyVersion = Vue.resource(
  `${API_ROOT}${participantManagement}${participants}/{pid}/${version}/{versionId}/${schedules}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantTaskScheduleIsCreatedForNewStudyVersion = Vue.resource(`${API_ROOT}${participantManagement}${participants}/{pid}/${version}/{versionId}/${checkschedules}`);

const resendOtpForCognito = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${participant}/${general}/${otp}/${resend}`);

const studyDetail = Vue.resource(`${API_PARTICIPANT_WEB_ROOT}${participant}/${general}/${studyDetails}`, {}, { update: { method: "GET" } });

//61129 end
const getDatavantWebToggleStateResource = Vue.resource(
  `${API_ROOT}${studyManagement}${studies}/{studyId}/mobile/studyfeatures`, 
  {}, {
    update: {
      method: 'GET'
    }
  },
);

const SendOtpForCreateUsername = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${participant}/${otp}/${send}`);
const sednOtpToVerifyEmail = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${participant}/${general}/${otp}/${send}`);

const checkUsernameResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${participant}/${checkUsername}`);

const changeEmailVerifyResource = Vue.resource(`${API_ROOT_V3}${participantManagement}${participants}{/pid}/${updateEmail}`, {});

const verifyEmailChangeResource = Vue.resource(`${API_ROOT_V2}${participantManagement}${participants}{/pid}/${emailVerificationStatus}`);

const verifyForgotUsernameOtp = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${participant}/${otp}/${verify}`);

const createUsernameResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${participant}/${username}/${verifyOtp}`);

const createUsernameNewResource = Vue.resource(`${COGNITO_API_US_WEB_ROOT}${participant}/${webRegister}`);

const participantSiteDetails = Vue.resource(`${API_ROOT}${participantManagement}${participants}{/pid}/${sites}`);

const principanInvestigatorPhone = Vue.resource(`${API_ROOT}${responsemanagement}${contact}/${pi}`);

const participantTelehealthAppointmentStatus = Vue.resource(`${API_ROOT_V2}${responsemanagement}${participants}/${appointmentStatus}`);

const participantTelehealthAppointementReschedule = Vue.resource(`${API_ROOT}${responsemanagement}${participants}/${appointmentReschedule}`);

const participantTelehealthAppointmentDetails = Vue.resource(`${API_ROOT}${responsemanagement}${telehealth2}/${site}{/pSiteId}/${appointment}`);

const participantTelehealthStartVideoCall = Vue.resource(`${API_ROOT_V2}${responsemanagement}${participants}/${videocallDetails}`);

const participantTelehealthRejectVideoCall = Vue.resource(`${API_ROOT_V2}${responsemanagement}${telehealth2}/${appointment}/${rejectVideoCall}`);

const participantPortalSignout = Vue.resource(`${API_ROOT_V2}${participantManagement}${participants}{/pid}/${participantportalsignout}`, {}, { update: { method: "PUT" } });

export function registerParticipantDevice(data) {
  return participantDeviceRegister.save(data);
}

export function getParticipantJavaCompatibleAccessToken(data) {
  return javaAccessTokenForParticipantResource.save(data);
}

export function getPrincipalInvestigatorPhone(queryParams) {
  return principanInvestigatorPhone.get({ ...queryParams });
}

export function getParticipantAppointmentSlots(pSiteId, queryParams) {
  return participantTelehealthAppointmentDetails.get({
    pSiteId,
    ...queryParams
  });
}

export function confirmParticipantAppointmentSlot(pSiteId, queryParams, data) {
  return participantTelehealthAppointmentDetails.update({ pSiteId, ...queryParams }, data);
}

export function getParticipantAppointment(queryParams) {
  return participantTelehealthAppointmentStatus.get({ ...queryParams });
}

export function rescheduleParticipantAppointmentSlot(pSiteId, queryParams, data) {
  return participantTelehealthAppointementReschedule.save({ pSiteId, ...queryParams }, data);
}

export function startParticipantVideoCall(queryParams) {
  return participantTelehealthStartVideoCall.get({ ...queryParams });
}

export function rejectParticipantVideoCall(queryParams) {
  return participantTelehealthRejectVideoCall.update({ ...queryParams }, {});
}

export function getSiteDetails(pid, queryParams) {
  return participantSiteDetails.get({ pid, ...queryParams });
}

export function getCountries() {
  return participantCountry.get();
}

export function getLanguages() {
  return participantLanguages.get();
}

export function getParticipantStudyTranslations(studyId, languageId) {
  return getParticipantWebTranslateData.get({ studyId, languageId });
}

export function getStaticLanguages(languageId) {
  return participantStaticLanguages.get({ languageId });
}

export function getStudies(queryParams) {
  return participantStudies.get({ ...queryParams });
}

export function getFirebaseApp(pId, queryParams) {
  return firebaseWebApp.get({ pId, ...queryParams });
}

export function renewParticipantTask(taskId, queryParams) {
  return participantRegenerateTask.get({ taskId, ...queryParams }, { headers: { clientId: clientId } });
}

export function getParticipantWebTranslation(studyId, languageId) {
  return participantsWebLanguageTranslations.get({ studyId, languageId });
}

export function getApplangaTranslation(studyId, studyVersionId, languageId) {
  return getParticipantsApplangaTranslation.get({
    studyId,
    studyVersionId,
    languageId
  });
}

export function getPortalCountryLanguage(studyId) {
  return getParticipantsCountryLanguages.get({
    studyId
  });
}

export function getPortalConfiguration(studyId, studyVersionId) {
  return getParticipantsConfiguration.get({
    studyId,
    studyVersionId
  });
}

export function getParticipantsProfileDetails(pid) {
  return participantsProfileDetails.get({
    pid
  });
}

export function getParticipantsScheduledActivities(participantId, studyVersionId, queryParams) {
  return participantsScheduledActivities.get({
    participantId,
    studyVersionId,
    ...queryParams
  });
}

export function getParticipantEmailStatus(participantId) {
  return participantEmailStatus.get({
    participantId
  });
}

export function getParticipantsNotifications(participantId, studyVersionId, queryParams) {
  return participantsNotifications.get({
    participantId,
    studyVersionId,
    ...queryParams
  });
}

export function updateParticipantDataFact(pid, data) {
  return participantsProfileDetailsf.update({ pid }, data);
}

export function getParticipantPortalDataFact(studyId, queryParams) {
  return participantPortalData.get({
    studyId,
    ...queryParams
  });
}

export function getDataFromURL(key) {
  return new Promise((resolve, reject) => {
    $.getJSON(key)
      .done(resolve)
      .fail(reject);
  });
}

export function getPortalActivityDetails(surveyId, queryParams) {
  return participantPortalActivityDetails.get({
    surveyId,
    ...queryParams
  });
}

export function changePassword(pid, data) {
  return changePasswordFact.save({ pid }, data);
}

export function getSmsToggleNotification(pid) {
  return participantSmsToggle.get({
    pid
  });
}

export function getVerificationPhoneSmsToggleNotification(pid) {
  return participantVerificationSmsToggle.get({
    pid
  });
}

export function getLearnMoreData(studyId, versionId) {
  return learnMoreData.get({
    studyId,
    versionId
  });
}

export function updateSmsToggleNotification(pid, queryParams) {
  return participantSmsToggle.update(
    {
      pid,
      ...queryParams
    },
    {}
  );
}

export function verificationPhoneSmsToggle(pid, queryParams) {
  return participantVerificationSmsToggle.update(
    {
      pid,
      ...queryParams
    },
    {}
  );
}

export function getPortalDashboardData(pid, studyId, participantCurrentDay, queryParams, data) {
  return participantDashboardPortalData.update(
    {
      pid,
      studyId,
      participantCurrentDay,
      ...queryParams
    },
    data
  );
}

export function postParticipantSendOtp(data) {
  return participantSendOtp.update(data);
}

export function postParticipantSendOtpToEmail(data) {
  return participantSendOtpToEmail.update(data);
}

export function postWithdrawStudyFact(pid, data) {
  return withdrawStudy.update({ pid }, data);
}

export function requestAccountDelete(pid, data) {
  return deleteParticipantAccount.update({ pid, participantId: pid }, data);
}

export function getPortalActivityDetailswithImageURls(surveyId, queryParams) {
  return ActivityDetailswithImageUrl.get({
    surveyId,
    ...queryParams
  });
}

export function getStudyAppMetadataFact(studyId) {
  return getStudyAppMetadata.get({ studyId });
}

export function getParticipantTodayActivityData(queryParams) {
  return getParticipantTodayActivity.get({ ...queryParams });
}

export function postParticipantNotification(pid, queryParams, studyVersionId, day, data) {
  return participantAllNotification.save({ pid, studyVersionId, day, ...queryParams }, data);
}

export function updateParticipantNotification(pid, queryParams, studyVersionId, day, data) {
  return participantAllNotification.update({ pid, studyVersionId, day, ...queryParams }, data);
}

export function getParticipantNotifications(pid, studyVersionId, day, data) {
  return participantAllNotification.save({ pid, studyVersionId, day }, data);
}

export function participantClearSingleNotification(pid, notificationId, data) {
  return participantSingleNotification.update({ pid, ...notificationId }, data);
}

export function putParticipantsClearNotifications(queryParams, pid, data) {
  return participantsClearNotifications.update({ pid, ...queryParams }, data);
}

export function saveParticipantsSurveyResponse(queryParams, data) {
  return participantsSurveyResponse.save({ ...queryParams }, data);
}

export function saveParticipantsActivityResponse(queryParams, data) {
  return participantsActivityResponse.save({ ...queryParams }, data);
}

export function saveParticipantsAactivityResponse(queryParams, data) {
  return participantsActivitiesResponse.save({ ...queryParams }, data);
}

export function getParticipantsRegisterConfig(studyId) {
  return participantsRegistrationConfig.get({ studyId });
}

export function getParticipantsWebCountryLanguages(studyId, version) {
  return participantsWebCountryLanguages.get({ studyId, version });
}

export function getParticipantAdharance(queryParams) {
  return participantDashboardPortalDetails.get({ ...queryParams });
}

export function updateParticipantAdharance(queryParams, data) {
  return participantDashboardPortalDetails.update({ ...queryParams }, data);
}

export function updateParticipantComplianceAdharance(queryParams, data) {
  return participantSurveyPostDetails.save({ ...queryParams }, data);
}

export function participantSignout(pid, data) {
  return participantPortalSignout.update({ pid }, data);
}

export function forgotUsernameFactParticipant(data) {
  return forgotUsernameResource.save(data);
}

export function sendOtpForCreateUsernameFact(data) {
  return SendOtpForCreateUsername.save(data);
}

export function sendOtpToVerifyEmail(data) {
  data.requestFrom = "web";
  return sednOtpToVerifyEmail.save(data);
}

export function checkUsernameFact(data) {
  data.requestFrom = "web";
  return checkUsernameResource.save(data);
}

export function changeEmailVerification(pathParams, queryParams, postData) {
  return changeEmailVerifyResource.update({ ...queryParams, ...pathParams }, postData);
}

export function checkEmailVerified(pid) {
  return verifyEmailChangeResource.get({ pid });
}

export function ForgotUsernameOtpVerify(data) {
  return verifyForgotUsernameOtp.save(data);
}

export function createParticipantUsername(data) {
  return createUsernameResource.save(data);
}

export function createParticipantUsernameWeb(data) {
  return createUsernameNewResource.save(data);
}

export function participantSignoutV3(pid, data) {
  return participantPortalSignoutV3.update({ pid }, data);
}
export function activateStudyCode(queryParams) {
  return participantJoinStudyActivate.update({ ...queryParams }, {});
}
export function participantProfileLearn(participantId, participantLocalTime, data) {
  return participantProfileLearnFeedback.save(
    {
      participantId,
      participantLocalTime
    },
    data
  );
}
export function participantEulaAgrement(pid, body) {
  return saveParticipantEulaAgrement.save({ pid }, body);
}
export function participantSaveCohort(body) {
  return saveParticipantCohort.save(body);
}
//Save consent
export function participantSaveConsent(consentID, body) {
  return saveParticipantConsent.save({ consentID }, body);
}
//Save datavant consent
export function participantSaveDatavantConsent(consentID, body) {
  return saveParticipantDatavantConsent.save({consentID}, body);
}
//signature and Disclamer
export function saveSignatureAndDisclamer(pid, body) {
  return participantSignatureAndDisclamer.save({ pid }, body);
}

//signature and Disclamer
export function saveDatavantSignatureAndDisclamer(params, body) {
  return participantDatavantSignatureAndDisclamer.save(params, body);
}

export function participantSaveConsents(pid, studyId, body) {
  return saveParticipantConsentOnBording.save({ pid, studyId }, body);
}
export function participantRegistration(language, country, data) {
  return participantJoinStudyRegistration.save(
    {
      language,
      country
    },
    data
  );
}
export function verifyParticipantEmail(body) {
  return participantVerifyEmail.update(body);
}
export function participantRegistrationCognito(language, country, data) {
  return participantJoinStudyRegistrationCognito.save(
    {
      language,
      country
    },
    data
  );
}
export function getParticipantDocuments(pid, studyId) {
  return participantDocuments.get({ pid, studyId });
}
export function getParticipantAddress(pid) {
  return participantAddress.get({ pid });
}

export function getParticipantVideos(studyId, pid) {
  return getParticipantVideosResource.get({ studyId, pid });
}

export function saveDocumentAndSignature(pid, studyId, body) {
  return saveParticipantDocument.save({ pid, participantId: pid, studyId }, body);
}
export function editEmailOnCognito(pid, languageId, payload) {
  return editEmailSave.update({ pid, languageId }, payload);
}
export function verifyCognitoUserEmail(payload) {
  return participantCognitoVerifyEmail.save({}, payload);
}
export function saveEligibility(payload) {
  return saveParticipantEligibility.save({}, payload);
}
export function confirmParticipant(pid, studyId, payload) {
  return saveConfirmParticipant.update({ pid, studyId }, payload);
}
export function getSiteApprovedLanguages(siteId, countryId) {
  return getParticipantSiteApprovedLang.get({
    siteId,
    countryId
  });
}
export function verifyPhoneOtp(pid, otp) {
  return verifyRegistrationPhoneOtp.update({ pid, otp }, {});
}
export function resendPhoneOtp(pid) {
  return resendRegistrationPhoneOtp.update({ pid }, {});
}
export function updateParticipantStudyVersion(payload) {
  return participantStudyVersion.save(payload, {});
}
export function isTaskScheduleCreatedForNewStudyVersion(payload) {
  return participantTaskScheduleIsCreatedForNewStudyVersion.get(payload);
}
export function resendUsernameOtp(data) {
  return resendOtpForCognito.save(data);
}
export function getStudyDetail(studyId) {
  return studyDetail.update({ studyId }, {});
}

export function getAvailableLanguagesConfiguration(studyId, studyVersionId, countryId) {
  return availableLanguagesConfiguration.get({
    studyId,
    studyVersionId,
    countryId
  });
}

export function getAvailableCountryConfiguration(studyId, studyVersionId, languageId) {
  return availableCountryConfiguration.get({
    studyId,
    studyVersionId,
    languageId
  });
}

export function getDatavantWebToggleState( payLoad) {
  return getDatavantWebToggleStateResource.get(payLoad);
}
